module.exports = __webpack_public_path__ + "resource/img/image035Dark.b1d52de3.png";